import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { API } from "@/lib/api";
import { PAGE_LABELS } from "@/lib/analytics";

export const PageViewTracker = () => {
  const { pathname } = useLocation();
  const previous = useRef(null);
  useEffect(() => {
    // No session IDs, cookies, referrers, query strings or browser storage writes.
    const path = pathname.replace(/\/+$/, "") || "/";
    if (previous.current === path) return;
    previous.current = path;
    if (!Object.hasOwn(PAGE_LABELS, path) || navigator.doNotTrack === "1" || navigator.globalPrivacyControl) return;
    try { if (localStorage.getItem("gfc_token")) return; } catch { /* storage is optional */ }
    fetch(`${API}/analytics/pageview`, { method: "POST", credentials: "omit", referrerPolicy: "no-referrer", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ path }), keepalive: true }).catch(() => {});
  }, [pathname]);
  return null;
};